import { RouteRecordRaw } from 'vue-router'

const publics: Array<RouteRecordRaw> = [
    {
        path: '/',
        redirect: '/workbench',
        component: () => import('@/views/index.vue'),
        children: [
            {
                path: '/index',
                name: 'index',
                meta: {
                    title: '待办',
                    keepAlive: true
                },
                component: () => import('@/views/tabPage/toBeHandled.vue')
            },
            {
                path: '/workbench',
                name: 'workbench',
                meta: {
                    title: '工作台',
                    keepAlive: false
                },
                component: () => import('@/views/tabPage/workBench.vue')
            },
            {
                path: '/bulletinboard',
                name: 'bulletinboard',
                meta: {
                    title: '看板',
                    keepAlive: false
                },
                component: () => import('@/views/tabPage/bulletinBoard.vue')
            },
            {
                path: '/my',
                name: 'my',
                meta: {
                    title: '我的',
                    keepAlive: false
                },
                component: () => import('@/views/tabPage/my.vue')
            }
        ]
    },
    {
        path: '/logInAgain',
        redirect: '/logInAgain',
        component: () => import('@/views/children.vue'),
        children: [
            {
                path: '/logInAgain',
                name: 'logInAgain',
                meta: {
                    title: '登录中...',
                    keepAlive: false
                },
                component: () => import('@/views/LogInAgain.vue')
            }
        ]
    },
    {
        path: '/autoLogin',
        name: 'autoLogin',
        meta: {
            title: '登录中',
            keepAlive: false
        },
        component: () => import('@/views/autoLogin.vue')
    },
    {
        path: '/autoLoginDemo',
        name: 'autoLoginDemo',
        meta: {
            title: '登录中',
            keepAlive: false
        },
        component: () => import('@/views/autoLoginDemo.vue')
    },
    {
        path: '/autoLoginEdgp',
        name: 'autoLoginEdgp',
        meta: {
            title: '登录中',
            keepAlive: false
        },
        component: () => import('@/views/autoLoginEdgp.vue')
    },
    {
        path: '/autoLoginDemoEdgp',
        name: 'autoLoginDemoEdgp',
        meta: {
            title: '登录中',
            keepAlive: false
        },
        component: () => import('@/views/autoLoginDemoEdgp.vue')
    },
    {
        path: '/wxLogin',
        name: 'wxLogin',
        meta: {
            title: 'DM云工厂',
            keepAlive: false
        },
        component: () => import('@/views/wxLogin.vue')
    }
]

export default publics;
